export default {
    HOME_RESET_PASSWORD_RESET_REQUEST: 'HOME_RESET_PASSWORD_RESET_REQUEST',
    HOME_UPDATE_RESET_FIELD: 'HOME_UPDATE_RESET_FIELD',
    HOME_CLEAR_RESET_FIELD: 'HOME_CLEAR_RESET_FIELD',
    HOME_UPDATE_PROPS: 'HOME_UPDATE_PROPS',
    HOME_TOGGLE_PASSWORD_RESET_MODAL: 'HOME_TOGGLE_PASSWORD_RESET_MODAL',

    HOME_PENDING_PASSWORD_RESET_REQUEST: 'HOME_PENDING_PASSWORD_RESET_REQUEST',
    HOME_SUCCESS_PASSWORD_RESET_REQUEST: 'HOME_SUCCESS_PASSWORD_RESET_REQUEST',
    HOME_FAILURE_PASSWORD_RESET_REQUEST: 'HOME_FAILURE_PASSWORD_RESET_REQUEST',
    HOME_CLEAR_REQUEST_PASSWORD_RESET: 'HOME_CLEAR_REQUEST_PASSWORD_RESET',

    HOME_PENDING_UPDATE_NEW_PASSWORD: 'HOME_PENDING_UPDATE_NEW_PASSWORD',
    HOME_SUCCESS_UPDATE_NEW_PASSWORD: 'HOME_SUCCESS_UPDATE_NEW_PASSWORD',
    HOME_FAILURE_UPDATE_NEW_PASSWORD: 'HOME_FAILURE_UPDATE_NEW_PASSWORD',
    HOME_RESET_UPDATE_NEW_PASSWORD_REQUEST: 'HOME_RESET_UPDATE_NEW_PASSWORD_REQUEST',

    HOME_PENDING_UPDATE_EXPIRED_PASSWORD: 'HOME_PENDING_UPDATE_EXPIRED_PASSWORD',
    HOME_SUCCESS_UPDATE_EXPIRED_PASSWORD: 'HOME_SUCCESS_UPDATE_EXPIRED_PASSWORD',
    HOME_FAILURE_UPDATE_EXPIRED_PASSWORD: 'HOME_FAILURE_UPDATE_EXPIRED_PASSWORD',
    HOME_RESET_UPDATE_EXPIRED_PASSWORD_REQUEST: 'HOME_RESET_UPDATE_EXPIRED_PASSWORD_REQUEST',

    HOME_PENDING_UPDATE_NEW_EMAIL: 'HOME_PENDING_UPDATE_NEW_EMAIL',
    HOME_SUCCESS_UPDATE_NEW_EMAIL: 'HOME_SUCCESS_UPDATE_NEW_EMAIL',
    HOME_FAILURE_UPDATE_NEW_EMAIL: 'HOME_FAILURE_UPDATE_NEW_EMAIL',
    HOME_RESET_UPDATE_EMAIL_UPDATE_REQUEST: 'HOME_RESET_UPDATE_EMAIL_UPDATE_REQUEST',

    CHECK_EXPIRED_REQUEST: 'CHECK_EXPIRED_REQUEST',
    CHECK_EXPIRED_SUCCESS: 'CHECK_EXPIRED_SUCCESS',
    CHECK_EXPIRED_FAILURE: 'CHECK_EXPIRED_FAILURE'
}
